import { programIdentifiersApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROGRAM_IDENTIFIERS_ACTION_TYPE = createNamedActions('programIdentifiers', {
  GET_PROGRAM_IDENTIFIERS: 'GET_PROGRAM_IDENTIFIERS',
  GET_PROGRAM_IDENTIFIERS_BY_ID: 'GET_PROGRAM_IDENTIFIERS_BY_ID',
  CREATE_PROGRAM_IDENTIFIERS: 'CREATE_PROGRAM_IDENTIFIERS',
  EDIT_PROGRAM_IDENTIFIERS: 'EDIT_PROGRAM_IDENTIFIERS',
  DELETE_PROGRAM_IDENTIFIERS: 'DELETE_PROGRAM_IDENTIFIERS',
});

const programIdentifiersSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getProgramIdentifiersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programIdentifiersApi.getProgramIdentifiers(params);

  return dispatch({
    type: PROGRAM_IDENTIFIERS_ACTION_TYPE.GET_PROGRAM_IDENTIFIERS,
    payload: normalize(data, [programIdentifiersSchema]).entities.data,
  });
});

export const createProgramIdentifiersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programIdentifiersApi.createProgramIdentifiers(params);

  return dispatch({
    type: PROGRAM_IDENTIFIERS_ACTION_TYPE.CREATE_PROGRAM_IDENTIFIERS,
    payload: data,
  });
});

export const editProgramIdentifiersByIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programIdentifiersApi.editProgramIdentifiers(params);

  return dispatch({
    type: PROGRAM_IDENTIFIERS_ACTION_TYPE.GET_PROGRAM_IDENTIFIERS_BY_ID,
    payload: data,
  });
});

export const deleteProgramIdentifiersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programIdentifiersApi.deletegetProgramIdentifiers(params);

  return dispatch({
    type: PROGRAM_IDENTIFIERS_ACTION_TYPE.DELETE_PROGRAM_IDENTIFIERS,
    payload: data,
    meta: params,
  });
});
